// src/views/Users/Customers/Customers.jsx
import { useState, useEffect, useRef } from "react";
import ActionsDataTable from "../../../shared/DataTable/ActionsDataTable";
import { globalConstants, modeConstants } from "../../../constants";
import { useNavigate } from "react-router-dom";
import AddCandidateModal from "../../../shared/Modals/CandidateModal";
import ActivityModal from "../../../shared/Modals/ActivityModal";
import ViewAllActivitiesModal from "../../../shared/Modals/ViewAllActivitiesModal";
import { useDispatch, useSelector } from "react-redux";
import {
  activityActions,
  candidateActions,
  projectActions,
  screenActions,
} from "../../../redux/actions";
import { SCREENS_IDS } from "../../../system";

export default function Candidates() {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "id desc",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sortingInProgressRef = useRef(false);

  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [showAllActivityModal, setShowAllActivityModal] = useState(null);

  // modal + row state
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showCandidateModal, setShowCandidateModal] = useState(false);
  const [rowData, setRowData] = useState({ items: [], total: 0 });
  const allData = useSelector((s) => s.candidateReducer.data);
  let isManager = useSelector((s) => s.recruiterReducer.isManager);

  const actions =
  // Actions
  {
    name: "Actions",
    sortable: false,
    width: "100px",
    cell: (row) => (
      <div
        className="d-flex align-items-center gap-2"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          title="Edit"
          aria-label="Edit"
          onClick={() => {
            getRowData(row, modeConstants.UPDATE_MODE);
            setShowCandidateModal(true);
          }}
        >
          <i className="bi bi-pencil" />
        </button>

        <button
          type="button"
          className="btn btn-sm btn-outline-success"
          title="View"
          aria-label="View"
          onClick={() => {
            getRowData(row, modeConstants.VIEW_MODE);
            setShowCandidateModal(true);
          }}
        >
          <i className="bi bi-eye" />
        </button>

        <div className="dropdown">
          <button
            className="btn btn-sm btn-outline-secondary"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            title="More"
          >
            <i className="bi bi-three-dots-vertical" />
          </button>
          <ul
            className="dropdown-menu dropdown-menu-end"
            onClick={(e) => e.stopPropagation()}
          >
            {!isManager && (
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => {
                    getRowData(row, modeConstants.ADD_MODE);
                    setShowActivityModal(true);
                  }}
                >
                  <i className="bi bi-plus-circle me-2" /> Add Activity
                </button>
              </li>
            )}
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  getActivitiesByCandidateId(row, modeConstants.ADD_MODE);
                  setShowAllActivityModal(true);
                }}
              >
                <i className="bi bi-collection me-2" /> View All Activities
              </button>
            </li>
          </ul>
        </div>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  }

  const getRowData = (row, nextMode) => {
    dispatch(candidateActions.getCandidateById(row.id));
    setMode(nextMode);
  };

  const getActivitiesByCandidateId = (row, nextMode) => {
    dispatch(candidateActions.getCandidateById(row.id));
    dispatch(activityActions.getAllActivity(initialGridState, row.id));
    setMode(nextMode);
  };

  const toggleStatus = (id) => {
    dispatch(candidateActions.deleteCandidateById(id));
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    dispatch(candidateActions.getAllCandidate(gridState));
  };
  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    dispatch(projectActions.getAllProjectList());
  }, []);

  useEffect(() => {
    if (!showAllActivityModal) {
      dispatch(screenActions.getColumnsByScreenId(SCREENS_IDS.ALL_CANDIDATES));
      dispatch(screenActions.getUserPreferencesByScreenId(SCREENS_IDS.ALL_CANDIDATES));
    }
  }, [showAllActivityModal]);

  return (
    <>
      {/* Candidate modal (create/edit/view) */}
      <AddCandidateModal
        show={showCandidateModal}
        onHide={() => setShowCandidateModal(false)}
        mode={mode}
        isProjectDataAvailable={false}
      />
      <ActivityModal
        show={showActivityModal}
        onHide={() => setShowActivityModal(false)}
        mode={mode}
      />

      {showAllActivityModal &&
        <ViewAllActivitiesModal
          show={showAllActivityModal}
          onHide={() => setShowAllActivityModal(false)}
        />
      }


      <ActionsDataTable
        actions={actions}
        data={rowData.items}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        paginationServer
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData.total}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setShowModal={setShowCandidateModal}
        setMode={setMode}
        setGridState={setGridState}
        isDownloadTemplate={true}
        sortServer={true}
        toggleStatus={toggleStatus}
        screenId={SCREENS_IDS.ALL_CANDIDATES}
      />
    </>
  );
}
